import Search from "./components/Search";
import Pagination from "./components/Pagination";
import Stories from "./components/Stories";
import "./App.css"

const App = () => {
  // const data = useGlobalContext();
  return (
    <>
    <Search/>
    <Pagination/>
    <Stories/>
    </>
    
  );
};

export default App

// 40:40 / 2:03:34